import { Component, AfterViewInit, AfterContentInit } from '@angular/core';
import '../../../public/css/style.css';
// import {FooterComponent} from './footer.component';
import { FooterComponent } from '../Theme/components/footer/footer.component';
import { Router } from '@angular/router';
import { REACTIVE_FORM_DIRECTIVES, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ControlMessages } from './login-message.component';
import { ValidationService } from './login-validation.service';
import { AuthService } from '../sharedServices/AuthService/auth.service';
import { ROUTER_DIRECTIVES } from '@angular/router';

declare const FB: any;
declare const jQuery: any;

@Component({
    selector: 'login',
    // directives: [FooterComponent],
    directives: [FooterComponent, REACTIVE_FORM_DIRECTIVES, ROUTER_DIRECTIVES, ControlMessages],
    providers: [AuthService],
    // template: '<h1>My First Angular 2 App</h1>',
    template: require('./login.html')
})


export class LoginComponent {

    private username: String;
    private phoneNumber: String;
    private fullName: String;
    private password: String;
    private signUpType: Number;
    private email: String;
    private deviceType: Number;
    private pushToken: String;
    private deviceId: String;
    private profilePicUrl: String;

    private bufferlogin = false;
    private buffer_login = false;
    signupForm: any;
    loginForm: any;
    resetForm: any;
    private loginMessage: any;
    private loginSuccess: any;
    private signupMessage: any;
    private signupSuccess: any;
    private resetSuccess: any;
    private reseterror: any;
    private token: any;
    private loged: boolean = false;
    private user: any;
    private fbloginerror: any;
    fbloginerror1: any;
    private error_icon = false;
    error_iconfb = false;
    accessToken: any;
    fbdisplayLogin = false;
    errPhone: any;
    OtpNumber: string;

    constructor(private _authService: AuthService, private formBuilder: FormBuilder, private _router: Router) {

        FB.init({
            appId: '1992785894293760',
            status: true,
            cookie: true,  // enable cookies to allow the server to access 
            xfbml: true,  // parse social plugins on this page 
            version: 'v2.11' // use graph api version 2.5 
        });

        this.signupForm = this.formBuilder.group({
            'username': ['', Validators.required],
            'fullName': ['', Validators.required],
            'email': ['', [Validators.required, ValidationService.emailValidator]],
            'password': ['', [Validators.required]]
        });
        this.loginForm = this.formBuilder.group({
            'username': ['', Validators.required],
            'password': ['', [Validators.required]]
        });
        this.resetForm = this.formBuilder.group({
            'email': ['', [Validators.required, ValidationService.emailValidator]],
        });

    }
    private hideElement = false;
    private displayLogin = false;
    private edited = false;

    ngOnInit() {
        var token = localStorage.getItem('authToken');
        if (token) {
            this._router.navigate(["home"]);
        }
        jQuery("#phone").intlTelInput();

    }

    ngAfterViewInit() {
        jQuery("#phone").intlTelInput({
            allowExtensions: false,
            autoFormat: true,
            autoHideDialCode: true,
            autoPlaceholder: true,
            customPlaceholder: null,
            defaultCountry: "gb",
            geoIpLookup: null,
            nationalMode: true,
            numberType: "MOBILE",
            onlyCountries: undefined,
            preferredCountries: ['gb', 'in', 'us'],
            skipUtilScriptDownload: false,
            // utilsScript: "../../../../../node_modules/intl-tel-input/build/js/utils.js",
        });
    }

    login() {
        this.registerEmpty();
        jQuery("#myModalAdmin").modal("hide");
        jQuery(".fbuserPassword").hide();
        jQuery(".signupUserotp").hide();
        this.displayLogin = true;
        this.hideElement = false;
        this.edited = false;
    }

    registerEmpty() {
        jQuery("#phone").val("");
        this.fullName = "";
        this.username = "";
        this.password = "";
    }

    authenticateUser() {

        this.bufferlogin = true;
        this._authService.login({ username: this.username, password: this.password })
            .subscribe((res) => {
                if (res.code == 200) {
                    setTimeout(() => {
                        this.bufferlogin = false;
                    }, 500);
                    // this.loginSuccess = res.message; 
                    setTimeout(() => {
                        // this._router.navigate(['home']);
                        window.location.replace('home');
                    }, 500);


                    //  alert(res.message);            
                }
                if (res.code == 1971) {
                    setTimeout(() => {
                        this.bufferlogin = false;
                    }, 500);
                    setTimeout(() => {
                        this.loginMessage = res.errMessage1;
                    }, 500);
                }
                if (res.code == 1972) {
                    setTimeout(() => {
                        this.bufferlogin = false;
                    }, 500);
                    setTimeout(() => {
                        this.loginMessage = res.errMessage2;
                    }, 500);
                }
                if (res.code == 1973) {
                    setTimeout(() => {
                        this.bufferlogin = false;
                    }, 500);
                    setTimeout(() => {
                        this.loginMessage = res.message;
                    }, 500);
                }
                if (res.code == 1974) {
                    setTimeout(() => {
                        this.bufferlogin = false;
                    }, 500);
                    setTimeout(() => {
                        this.loginMessage = res.message;
                    }, 500);
                    //    alert(res.message);       
                }

            });
    }

    register() {
        this.displayLogin = false;
        this.hideElement = false;
        this.edited = false;
    }

    forgot() {
        this.hideElement = true;
        this.edited = true;
    }


    // private right_icon=false;
    registerUser() {
        this.errPhone = false;
        var phonecheck = jQuery(".sign_validation").val();
        // var fullName = jQuery(".fullname").val();
        var username = jQuery(".sign_validation1").val();
        var fullname_register = jQuery('.fullname_register').val();
        var password_signup = jQuery('.sign_validation2').val();

        if (fullname_register) {
            jQuery(".fullname_register").siblings().removeClass("error");
            jQuery(".fullname_register").siblings().addClass("right");
        }
        if (password_signup) {
            jQuery(".sign_validation2").siblings().removeClass("error");
            jQuery(".sign_validation2").siblings().addClass("right");
        }

        if (username) {
            this._authService.signupusernamecheck({
                username: username,
            })
                .subscribe((res) => {
                    if (res.code == 1994) {
                        // this.error_icon = false;
                        jQuery(".sign_validation1").siblings().removeClass("right");
                        jQuery(".sign_validation1").siblings().addClass("error");
                        jQuery(".error_show").hide();
                    }

                    if (res.code == 200) {
                        this.error_icon = false;
                        jQuery(".sign_validation1").siblings().removeClass("error");
                        jQuery(".sign_validation1").siblings().addClass("right");
                        jQuery(".error_show").hide();
                    }
                });
        }

        if (phonecheck) {
            this._authService.phoneNumbercheck({
                phoneNumber: phonecheck,
            }).subscribe((res) => {
                // console.log(res);
                if (res.code == 1988) {
                    // this.error_icon = false;
                    jQuery("#phoneErr").removeClass("right");
                    jQuery("#phoneErr").addClass("error");
                    jQuery(".error_show").hide();
                }
                if (res.code == 200) {
                    this.error_icon = false;
                    jQuery("#phoneErr").removeClass("error");
                    jQuery("#phoneErr").addClass("right");
                    jQuery(".error_show").hide();
                }
            });
        }

    }

    mobileValidation(value: any) {
        var val = value.replace(/([^+0-9]+)/gi, '')
        jQuery(".sign_validation").val(val);
    }

    registerUsersubmitList() {

        if (jQuery('.sign_validation').val() != '') {
            jQuery("#phoneErr").removeClass("error");
            jQuery("#phoneErr").addClass("right");
            jQuery(".error_show").hide();
        } else {
            jQuery("#phoneErr").removeClass("right");
            jQuery("#phoneErr").addClass("error");
            jQuery(".error_show").show();
        }
        if (jQuery('.sign_validation1').val() != '') {
            jQuery(".sign_validation1").siblings().removeClass("error");
            jQuery(".sign_validation1").siblings().addClass("right");
            jQuery(".error_show").hide();
        } else {
            jQuery(".sign_validation1").siblings().removeClass("right");
            jQuery(".sign_validation1").siblings().addClass("error");
            jQuery(".error_show").show();
        }
        if (jQuery('.sign_validation2').val() != '') {
            jQuery(".sign_validation2").siblings().removeClass("error");
            jQuery(".sign_validation2").siblings().addClass("right");
            jQuery(".error_show").hide();
        } else {
            jQuery(".sign_validation2").siblings().removeClass("right");
            jQuery(".sign_validation2").siblings().addClass("error");
            jQuery(".error_show").show();
        }

        var phonecheck = jQuery("#phone").val();
        let list = {
            deviceId: 'browser',           //Signup via email
            phoneNumber: phonecheck
        }
        if (jQuery('.sign_validation').val() && jQuery('.sign_validation1').val() && jQuery('.sign_validation2').val()) {
            this.bufferlogin = true;
            setTimeout(() => {
                this.bufferlogin = false;
            }, 3000);
            this._authService.generateOTPCheck(list)
                .subscribe((res) => {
                    this.bufferlogin = false;
                    // console.log(res);
                    if (res.code == 200) {
                        this.errPhone = false;
                        jQuery(".fbuserPasswordsign").hide();
                        jQuery(".signupUserotp").show();
                    } else {
                        this.errPhone = "Please try entering your full number, including the country";
                        setTimeout(() => {
                            this.errPhone = false;
                        }, 3000);
                    }
                });
        }

    }


    registerUsersubmit() {

        // function ValidateEmail(email: any) {
        //     var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        //     return expr.test(email);
        // }
        // if (!ValidateEmail(jQuery(".sign_validation").val())) {
        //     //alert("Invalid email address.");
        //     jQuery(".sign_validation").siblings().removeClass("right");
        //     jQuery(".sign_validation").siblings().addClass("error");
        //     jQuery(".error_show").show();
        //     jQuery(".error_email").show();
        // }
        // else {
        //     //alert("Valid email address.");
        //     jQuery(".sign_validation").siblings().removeClass("error");
        //     jQuery(".sign_validation").siblings().addClass("right");
        //     jQuery(".error_show").hide();
        //     jQuery(".error_email").hide();
        // }
        // if (jQuery('.sign_validation1').val() != '') {
        //     jQuery(".sign_validation1").siblings().removeClass("error");
        //     jQuery(".sign_validation1").siblings().addClass("right");
        //     jQuery(".error_show").hide();
        // } else {
        //     jQuery(".sign_validation1").siblings().removeClass("right");
        //     jQuery(".sign_validation1").siblings().addClass("error");
        //     jQuery(".error_show").show();
        // }
        // if (jQuery('.sign_validation2').val() != '') {
        //     jQuery(".sign_validation2").siblings().removeClass("error");
        //     jQuery(".sign_validation2").siblings().addClass("right");
        //     jQuery(".error_show").hide();
        // } else {
        //     jQuery(".sign_validation2").siblings().removeClass("right");
        //     jQuery(".sign_validation2").siblings().addClass("error");
        //     jQuery(".error_show").show();
        // }

        // if (ValidateEmail(jQuery(".sign_validation").val()) && jQuery('.sign_validation1').val() && jQuery('.sign_validation2').val()) {
        var phonecheck = jQuery("#phone").val();
        this.bufferlogin = true;
        setTimeout(() => {
            this.bufferlogin = false;
        }, 3000);
        this._authService.register({
            signupType: 3,           //Signup via email
            phoneNumber: phonecheck,
            otp: this.OtpNumber,
            username: this.username,
            fullName: this.fullName,
            deviceType: 3,
            pushToken: 'browser',
            profilePicUrl: null,
            password: this.password,
            deviceId: 'browser'
        })
            .subscribe((res) => {
                console.log(res);
                // if (res.code == 2004) {
                //     jQuery(".sign_validation").siblings().removeClass("right");
                //     jQuery(".sign_validation1").siblings().removeClass("right");
                //     this.error_icon = true;
                //     setTimeout(() => {
                //         this.bufferlogin = false;
                //     }, 500);
                //     setTimeout(() => {
                //         this.signupMessage = res.message;
                //     }, 500);
                // }

                if (res.code == 200) {
                    setTimeout(() => {
                        this.bufferlogin = false;
                    }, 500);
                    // this.signupSuccess = res.message;     
                    setTimeout(() => {
                        // this._router.navigate(['home']);
                        // this.OtpNumber = "";
                        // jQuery("#myModalAdmin").modal("show");
                        window.location.replace('home');
                    }, 500);
                } else {
                    this.loginMessage = res.message;
                    setTimeout(() => {
                        this.loginMessage = false;
                    }, 3000);
                }
            });
        // }
    }


    forgotPassword() {
        this.bufferlogin = true;
        this._authService.resetPassword({
            email: this.email,
            type: '0'
        }).subscribe((res) => {
            if (res.code == 200) {
                setTimeout(() => {
                    this.bufferlogin = false;
                }, 500);
                this.resetSuccess = res.message;
                setTimeout(() => {
                    this.resetSuccess = " ";
                    jQuery("#forgotemail").val(" ");
                    this.displayLogin = false;
                    this.hideElement = false;
                    this.edited = false;
                }, 2000);
            }
            if (res.code == 1976) {
                setTimeout(() => {
                    this.bufferlogin = false;
                }, 500);
                this.reseterror = res.message;
                setTimeout(() => {
                    this.reseterror = " ";
                    jQuery("#forgotemail").val(" ");
                    this.displayLogin = false;
                    this.hideElement = false;
                    this.edited = false;
                }, 2000);
            }
        });
    }

    userNameCheck(val: any) {

        this._authService.userNameCheckList(val)
            .subscribe((res) => {
                this.error_iconfb = true;
                if (res.code != 200) {
                    // this.loginMessage = res.message;
                    jQuery(".fberror").removeClass("right");
                } else {
                    jQuery(".fberror").addClass("right");
                }

            });
    }

    fbauthenticateUser() {
        let list = {
            name: this.username,
            password: this.password,
            id: this.accessToken
        }
        this.bufferlogin = true;
        setTimeout(() => {
            this.buffer_login = false;
            jQuery(".loaderFb").hide();
        }, 3000);
        this._authService.registerfacebooklogin(list)
            .subscribe((res) => {
                this.buffer_login = false;
                if (res.code == 200) {
                    // this._router.navigate(['home']);
                    window.location.replace('home');
                } else {
                    this.loginMessage = res.message;
                }
            });
    }


    onFacebookLoginClick(): void {
        FB.getLoginStatus((response: any) => {
            // console.log(response);
            this.statusChangeCallback(response);
        })
    }

    statusChangeCallback(response: any) {
        if (response.status === 'connected') {
            this.fb_login();
            this.accessToken = response.authResponse.accessToken;
        } else {
            this.fblogin();
        }
    }

    fblogin() {
        FB.login((result: any) => {
            this.loged = true;
            this.token = result;
            this.fb_login();
        }, { scope: 'user_friends' });
    }


    me() {
        FB.getLoginStatus((response: any) => {
            if (response) {
                this.accessToken = response.authResponse.accessToken;
                // console.log(response);
            }
        })
        FB.api('/me?fields=id,name,first_name,email,gender',
            (result: any) => {
                this.user = result;
                this.user.id = this.accessToken;
                this.fbdisplayLogin = true;
                // console.log(this.user);
                // this.buffer_login = true;
                // setTimeout(() => {
                //     this.buffer_login = false;
                //     jQuery(".loaderFb").hide();
                // }, 5000); 
                // this._authService.registerfacebooklogin(this.user)
                //     .subscribe((res) => {
                //         if (res.code == 2005) {
                //             jQuery(".loaderFb").hide();
                //             // this.fb_login();
                //         } else if (res.code == 200) {
                //             jQuery(".loaderFb").hide();
                //             this._router.navigate(['home']);
                //         } else {
                //             jQuery(".loaderFb").hide();
                //             this.fbloginerror = res.message;
                //         }
                //     });
            });
    }

    fb_login() {
        FB.api('/me?fields=id,name,first_name,email,gender',
            (result: any) => {
                this.user = result;
                this.buffer_login = true;
                setTimeout(() => {
                    this.buffer_login = false;
                    jQuery(".loaderFb").hide();
                }, 5000);
                this._authService.facebooklogin(this.user)
                    .subscribe((res) => {
                        this.buffer_login = false;
                        jQuery(".loaderFb").hide();
                        if (res.code == 200) {
                            // this._router.navigate(['home']);
                            window.location.replace('home');
                        } else {
                            // jQuery(".fberror").show();                                                   
                            this.me();
                            jQuery(".fbuserPasswordsign").hide();
                            jQuery(".fbuserPassword").show();
                            // this.fbloginerror1 = res.message;
                        }
                    });
            });
    }

    signupUser() {
        if (this.signupForm.dirty && this.signupForm.valid) {
            // alert("hi");
            // window.location.href="http://localhost:8080/";
            //  alert(`Username: ${this.signupForm.value.username} Email: ${this.signupForm.value.email}`);
        }
    }

    loginUser() {
        if (this.loginForm.dirty && this.loginForm.valid) {
            // alert(`Username: ${this.loginForm.value.username} Password: ${this.loginForm.value.password}`);
        }
    }


}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/AuthModule/login.component.ts
 **/